<template>
    <div>
        <div class="searchcontent headersearch"  >
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">   
                <el-form-item>
                    <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入申请人姓名" ></el-input>
                </el-form-item>
                 <el-form-item>
                    <el-input size="small" v-model.trim="certificateNo" placeholder="请输入申请人证件号"  maxlength="18"  onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size="small" v-model="searchForm.policy" placeholder="请选择政策措施" style="width:250px">
                        <el-option
                        v-for="item in searchForm.policylist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item>
                    <el-select size="small"   style="width:150px" v-model="searchForm.year" placeholder="请选择年份" @change="yearChange(searchForm.year)">
                        <el-option
                        v-for="item in searchForm.arrYear"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                         
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isannuallist==true">
                    <el-select size="small"   style="width:150px" v-model="searchForm.annual" placeholder="请选择审核状态" >
                        <el-option
                        v-for="item in searchForm.annuallist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                         
                        ></el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item>
                    <el-select size="small"   style="width:150px" v-model="searchForm.registered" placeholder="请选择户口性质" >
                        <el-option
                        v-for="item in searchForm.registeredlist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                         
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-select size="small"   style="width:250px" v-model="searchForm.sex" placeholder="请选择申请人年龄">
                        <el-option
                        v-for="item in searchForm.sexlist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                         
                        ></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item v-if="show">
                          <el-select size="small" v-model="searchForm.countryID"  style="width:200px"  placeholder="请选择户籍乡级行政区划" @change="searchFormchange(5,searchForm.countryID)" >
                                  <el-option
                                  v-for="item in countryList"
                                  :key="item.baseRegionID"
                                  :label="item.baseRegionName"
                                  :value="item.baseRegionID"
                                  >
                              </el-option>
                          </el-select>
                </el-form-item>     
                <el-form-item v-if="show">
                    <el-select size="small" v-model="searchForm.villageID" style="width:200px"  placeholder="请选择户籍村级行政区划"  >
                            <el-option
                            v-for="item in villageList"
                            :key="item.baseRegionID"
                            :label="item.baseRegionName"
                            :value="item.baseRegionID"
                            >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="villshow">
                    <el-select size="small" v-model="searchForm.villageID" style="width:200px"  placeholder="请选择户籍村级行政区划"  >
                            <el-option
                            v-for="item in villageList"
                            :key="item.baseRegionID"
                            :label="item.baseRegionName"
                            :value="item.baseRegionID"
                            >
                        </el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item>
                    <el-button size="small" plain type="primary" icon="el-icon-search"  @click="onSearch">查询</el-button>
                </el-form-item>
                <el-form-item  >
                    <el-button size="small" plain type="primary" icon="el-icon-upload2" @click="onDownload">导出</el-button>
                </el-form-item>
                 <el-form-item v-if="isshow==false">
                    <el-button size="small" plain type="primary" icon="el-icon-s-check" v-if="permission.isHaverewardannualreviewbatchaudit" @click="onclickApplaylist()" >批量年审</el-button>
                </el-form-item>
                <el-form-item v-if="isshow==true">
                    <el-button size="small" plain type="info" icon="el-icon-s-check"  @click="onclickApplaylist()" v-if="permission.isHaverewardannualreviewbatchaudit" disabled>批量年审</el-button>
                </el-form-item>
              
            </el-form>
        </div>
        <div class="searchtable" >
            <el-table
                ref="table"
                :data="applyaudituserlist"
                 border
                stripe
                v-loading="showDataLoading"
                :header-row-style="{height:'30px'}"
                :header-cell-style="{padding:'5px'}"
                :row-style="{height:'30px'}"
                :cell-style="{padding:'5px'}"
                :height="tableHeight"
                @selection-change="handleSelectionPolicyChange"
                >
                <el-table-column
                    type="selection"
                    width="55" :selectable='checkboxSelect'>
                </el-table-column>
                <el-table-column prop="" label="编号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
                </el-table-column>
                <el-table-column
                    prop="realName"
                    label="申请人姓名"
                    width="100"
                    >
                </el-table-column>
             
                 <el-table-column
                    label="性别"
                    width="60" 
                   >
                    <template slot-scope="scope">
                        <span v-if="scope.row.sexID == 1">男</span>
                        <span v-if="scope.row.sexID == 2">女</span> 
                    </template>   
                </el-table-column>
                 <el-table-column
                    prop="userBirthday"
                    label="出生年月"
                    width="100"
                   >
                </el-table-column>
                 <el-table-column
                    prop="certificateNo"
                    label="身份证号"
                    width="165"
                   >
                </el-table-column>
                 <el-table-column
                    label="户口性质"
                    width="85"
                   >
                  <template slot-scope="scope">
                        <span v-if="scope.row.accountNature == 1">农业</span>
                        <span v-if="scope.row.accountNature == 2">非农业</span> 
                  </template>
                   
                </el-table-column>
                 <el-table-column
                    prop="maritalStatus"
                    label="婚姻状况"
                    width="85"
                   >
                   <!-- 1初婚；2再婚；3离婚；4丧偶 -->
                    <template slot-scope="scope">
                        <span v-if="scope.row.maritalStatus == 1">初婚</span>
                        <span v-if="scope.row.maritalStatus == 2">再婚</span> 
                        <span v-if="scope.row.maritalStatus == 3">离婚</span>
                        <span v-if="scope.row.maritalStatus == 4">丧偶</span>
                    </template>  
                </el-table-column>
                
                  <el-table-column
                    prop="surviveChildrenNum"
                    label="现子女数"
                    width="85"
                   >
                </el-table-column>
                  <el-table-column
                    prop="enjoyCensusAddress"
                    label="户籍地"
                    min-width="180"
                   >
                </el-table-column>
                <el-table-column
                    prop="currentCensusAddress"
                    label="现住地"
                    min-width="180"
                   >
                </el-table-column>
                  <el-table-column
                    prop="contactTel"
                    label="联系电话"
                     width="120"
                   >
                </el-table-column>
                <el-table-column
                    label="审核状态"
                     width="120"
                   >
                
                  <template slot-scope="scope" >
                     <div v-if="scope.row.auditStatus==0">
                            <span>乡级待年审</span>
                      </div>
                      <div  v-if="scope.row.auditStatus==1">
                          <!-- 扶助对象 -->
                            <span v-if="scope.row.confirmStatus ==0">区级待年审</span>
                            <!-- <span v-if="scope.row.confirmStatus == 1">已年审</span>  -->
                            <span v-if="scope.row.confirmStatus == 1">年审通过</span> 
                      </div>
                      <div v-if="scope.row.auditStatus==2">
                          <!-- 退出对象 -->
                            <span v-if="scope.row.confirmStatus ==0">区级待年审</span>
                            <span v-if="scope.row.confirmStatus == 1">年审不通过</span> 
                      </div>
                  </template>
                   
                </el-table-column>
                
                <el-table-column
                    label="操作"
                   width="160" >
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="editFunds(scope.row)"  >查看资料</el-button>
                        <!-- 区级 -->
                        <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"     class="tablecolumn" v-if="permission.isHaverewardannualreviewbatchaudit&&region_level==4 && (scope.row.auditStatus==1 || scope.row.auditStatus==2)&&scope.row.confirmStatus ==0" :disabled="isshow" @click="onclickApplay(scope.row)">年审确认</el-button>
                         <!-- 乡级 -->
                         <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"     class="tablecolumn" v-if="permission.isHaverewardannualreviewbatchaudit &&region_level==5 && scope.row.auditStatus==0" :disabled="isshow" @click="onclickApplay(scope.row)">年审</el-button>
                        <!-- <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"    class="tablecolumn"  @click="turnAnnualReview(scope.row)">转年审</el-button> -->
                        <!-- <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini"    class="tablecolumn" v-if="permission.isHaverewardchangeannualreview&& scope.row.auditStatus == 3" @click="turnAnnualReview(scope.row)" :disabled="auditStatusdisabled">转年审</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pageblock">
            <el-pagination
            @size-change="handledatailSizeChange"
            @current-change="handledatailCurrentChange"
            :current-page="page"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="datailtotalCount"
            >
            </el-pagination>
             </div>
        </div>
        <!-- 查看资料 -->  
        <el-dialog title="查看资料" :show-close="true"
          :close-on-click-modal="false"
          custom-class="dialog_wrap"
          :visible.sync="dialogdataFormVisible"
          class="eldialog"
          :modal-append-to-body="true"
          append-to-body
          :style="'margin-top:0px;left:' + initLeft()"
           @close="clearlookoverList()" 
          
          >
            <Particulars :valueID="applyRecordID"  :indexID="keyindex" :markID="mark" :markshow="markshowID"  :markauditStatus="markauditStatusID" :markuser="markuserID" :markpolicyMeasure="markpolicyMeasureID" :markrewardRecord="markrewardRecordID" :filterShowdata="dialogdataFormVisible" @getStatedata="getTypedata"></Particulars>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogdataFormVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 审核 -->
        <el-dialog title="年审" :visible.sync="dialogFormVisible" :show-close="true"  custom-class="dialog_wrap"    @close="clearEditList('checkedForm')"   style="margin-top:0px;left: 0px;z-index: 2154;"  class="logindialog" width="600px">
            <el-form ref="checkedForm"  label-width="130px" :model="checkedForm">
                <el-form-item label="审核年份：">
                    <el-select size="small"   style="width:150px" v-model="checkedForm.year" placeholder="请选择年份" @change="checkedFormyearChange(checkedForm.year)">
                        <el-option
                        v-for="item in checkedForm.arrYear"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核日期：" >
                    <el-date-picker
                        size="medium"
                        format="yyyy-MM-dd"
                        v-model="checkedForm.stattime"
                        value-format="timestamp"
                        type="date"
                        placeholder="请选择审核日期"
                        :picker-options="pickerOptions2"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="是否通过" >
                    <el-radio v-model="checkedForm.is_audit_pass" label="0">否</el-radio>
                    <el-radio v-model="checkedForm.is_audit_pass" label="1">是</el-radio>
                </el-form-item>
                <el-form-item label="不通过原因：" prop="people_logout_reason_id"  v-if="checkedForm.is_audit_pass==`0`">
                        <el-select size="medium" v-model="checkedForm.noPassReason" placeholder="请选择不通过原因" @change="selectchange">
                            <el-option
                            v-for="item in checkedForm.noPassReasonList"
                            :key="item.systemCodeID"
                            :label="item.systemCodeName"
                            :value="item.systemCodeID">
                            </el-option>
                        </el-select>
                </el-form-item> 
                
                <el-form-item   v-if="checkedForm.systemCode==99">
                    <div icon="el-icon-search" style="color:red">跨地区迁移个案不能选其他做退出处理，请到所属地变更操作</div>
                </el-form-item>  
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="medium" type="primary"  @click="oncheckSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { applyauditfailedlistModel,rewardannualreviewuserlistModel } from "@/request/windowtoaccept.js";
import { policydeclarationinfoModule } from "@/request/windowtoaccept.js";
import { regionModule } from "@/request/systemmange.js";
import router from "@/router.js";
import { sysframe } from '@/tools/sysframe.js'
import $ from 'jquery'
import store from '@/store'
import Particulars from "@/components/windowtoaccept/particulars.vue";
import {publicFun} from '@/tools/time.js'
import {baseconfig} from '@/config.js'
import { permissionTool } from "@/tools/permissiontool.js";
import { applyauditfinishModel } from "@/request/applyauditmanage.js";
import { systemcodeModule } from "@/request/systemmange.js";
export default {
   components: {
        Particulars,
    },
    props: ["valueID","indexID","markID","markrewardRecord","markpolicyMeasure","markuser","markshow","markauditStatus","filterShowdata"],
    data() {
        return {
            pickerOptions2: {
                disabledDate: (time) => {
                    if (this.checkedForm.stattime != "") {
                        return time.getTime() > Date.now() ;
                    } else {
                        return time.getTime() > Date.now();
                    }
            },
           },
            auditshow:false,
            isshow:true,
            auditStatusdisabled:true,
            // 审核状态
            markshowID:0,
            markauditStatusID:0,
            markpolicyMeasureID:0,
            markuserID:0,
            markrewardRecordID:0,
            mark:2,
            keyindex:0,
            // 审核
            rewardRecordIDlist:[],
            policyMeasureIDlist:[],
            userIDlist:[],

            applyRecordID:0,
            tableHeight:400,
            villageList:[],
            countryList:[],
            villageList1:[],
            countryList1:[],
            show:false,
            villshow:false,
            p_region_id:'',
            region_level:'',
            systemlist: [],

            lsp: [],
            permission: {
                isHaveLookPermission: false,
                isHaverewardannualreviewbatchaudit: false,
                isHaverewardchangeannualreview: false,
            },
            //进来加载数据是否展示loading圈
            showDataLoading: true,
            
            //搜索
            page: 1,
            pagesize: 10,
            datailtotalCount: 0,
            applyaudituserlist:[],
            // 搜索
            isannuallist:true,
            searchForm:{
                countryID:'',
                villageID:'',
                yearname:'',
                keywords:'',
                policylist:[],
                policy:'',
                year:'',
                arrYear:[],
                annual:'',
                
                annuallist:[
                    { value: -1, label: "全部" },
                    { value: 1, label: "乡级待年审" },
                    { value: 2, label: "区级待年审" },
                    { value: 3, label: "年审通过" },
                    { value: 4, label: "年审不通过" },
                ],
                //户口性质
                registered:'',
                registeredlist:[
                    {
                        value:0,
                        label:'全部'
                    },
                    {
                        value:1,
                        label:'农业'
                    },
                    {
                        value:2,
                        label:'非农业',
                    },
                ],
                sexlist:[
                    // 1：60~70；2：70~80；3：80~90；4：90~100；5：100以上
                    {
                        value:0,
                        label:'全部'
                    },
                    {
                        value:1,
                        label:'60~70'
                    },
                    {
                        value:2,
                        label:'70~80',
                    },
                    {
                        value:3,
                        label:'80~90',
                    },
                     {
                        value:4,
                        label:'90~100',
                    },
                    {
                        value:5,
                        label:'100以上',
                    },
                ]
            },
            dialogdetailVisible:false,
            dialogdataFormVisible:false,
            dialogFormVisible:false,
            // 审核
            checkedForm:{
                is_audit_pass: "0",
                systemCode:'',
                noPassReason:'',
                noPassReasonList:[],
                noPassReasontext:'',
                apply_record_ids:'',
                user_ids:'',
                policy_measure_id:'',
                type:0,
                stattime:'',
                yearname:'',
                year:'',
                arrYear:[],
            },
            // 批量审核
            multiplePolicySelection:[],
            thisYears:0,
            selectpolicy:'',
            certificateNo:''
            };
        },
  created: async function () {
    // var myDate = new Date();    
    var now = new Date(); 
    var FullYeartime=now.getFullYear()+"-"+((now.getMonth()+1)<10?"0":"")+(now.getMonth()+1)+"-"+(now.getDate()<10?"0":"")+now.getDate();
    this.checkedForm.stattime=new Date(FullYeartime.split(" ")).getTime();
    console.log(FullYeartime,this.checkedForm.stattime) 
    await this.funyear()
    console.log(9999,this.searchForm.yearname)
    await this. getapplyaudit1userlist(1,this.pagesize,'',0,0,this.searchForm.yearname,0,0,-1,0,0,0,0,this.certificateNo)
    await this.getpolicymeasureinfoalllist()
    
    this.tableHeight=($(".tab-content").height()-30-$(".searchcontent").outerHeight(true)-$(".pageblock").outerHeight(true))+'px'
    this.p_region_id =  store.getters.adminRegionID
    this.region_level = parseInt(store.getters.adminRegionLevel) +1
    console.log(this.region_level)
    console.log(this.region_level == 4)
    if( this.region_level == 4){
        this.isannuallist=false
        this.auditshow=true
        this.show = true
        this.isshow=false
        this.auditStatusdisabled=false
        this.getRegionList(this.region_level,this.p_region_id)      
    }
    if(this.region_level == 5){
        this.isannuallist=false
        this.auditshow=true
        this.villshow=true
        this.isshow=false
        this.auditStatusdisabled=true
        console.log(11111,this.villshow)
        this.getRegionList(this.region_level,this.p_region_id)
    }
    console.log(this.isshow,this.auditStatusdisabled)
    this.permission.isHaveLookPermission = permissionTool.isHavePermission(
      "rewardannualreviewbatchaudit",
      this.lsp
    );
    this.permission.isHaverewardannualreviewbatchaudit = permissionTool.isHavePermission(
      "rewardannualreviewbatchaudit",
      this.lsp
    );
    this.permission.isHaverewardchangeannualreview = permissionTool.isHavePermission(
      "rewardchangeannualreview",
      this.lsp
    );
    //this.getSystemcodeinfogetlist(18)


    
  },
  mounted: function () {},
  methods: {
    initLeft(){
        return sysframe.getSideBarLeft()
    },
       //获取城市列表
    async getRegionList(region_level,p_region_id) {
        await regionModule
            .regioninfogetlist(region_level,p_region_id)
            .then((response) => {
            switch (response.data.code) {
               case 100:{
                       let obj={
                            baseRegionID:-1,
                            baseRegionName:'全部'
                        }
                      if(region_level==1){
                        this.provinceList=response.data.result
                      }else if(region_level==2){
                         this.cityList=response.data.result
                      }else if(region_level==3){
                         this.districtList=response.data.result
                      }else if(region_level==4){
                         this.countryList=response.data.result
                         this.countryList.unshift(obj)
                      }else if(region_level==5){
                         this.villageList=response.data.result
                         this.villageList.unshift(obj)
                      }
                    //this.toDeal(response.data.result);
                    }
                    break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
            this.loading = false;
        });
    },
    // 3政策措施类型下拉框
    async getpolicymeasureinfoalllist() {
        await policydeclarationinfoModule.policymeasureinfoalllist()
            .then((response) => {
            switch (response.data.code) {
                case 100:{
                        let obj={
                            policyMeasureID:-1,
                            pmP1:'全部'
                        }
                        response.data.result.unshift(obj)
                        let arr=[]
                        response.data.result.forEach(e=>{
                            let obj={
                                value:e.policyMeasureID,
                                label:e.pmP1
                            }
                            arr.push(obj)
                        })
                        this.searchForm.policylist=arr
                    }
                break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
        });
    },
    //年份
    funyear(){
        var myDate = new Date();       
        var thisYear = myDate.getFullYear();  // 获取当年年份
        this.searchForm.yearname=myDate.getFullYear()
        this.checkedForm.yearname=myDate.getFullYear()
        var Section = thisYear - 2021;  // 声明一个变量 获得当前年份至想获取年份差 eg.2008
        this.searchForm.arrYear = []; // 声明一个空数组 把遍历出的年份添加到数组里
        this.checkedForm.arrYear = [];
        
        for(var i = 0;i<=Section;i++){
            let obj={
                value:i,
                label:thisYear--
            }
            this.searchForm.arrYear.unshift(obj)
            this.checkedForm.arrYear.unshift(obj)
                
            
            // arrYear.push(thisYear--)
        } // 遍历并添加年份到数组
            let allobj={
                value:-1,
                label:'全部'
            }
        this.searchForm.arrYear.unshift(allobj)
        // this.checkedForm.arrYear.unshift(allobj)
        this.searchForm.arrYear.forEach(e=>{
            if(this.searchForm.yearname==e.label){
                this.searchForm.year=e.value
            }
        })
         this.checkedForm.arrYear.forEach(e=>{
            if(this.checkedForm.yearname==e.label){
                this.checkedForm.year=e.value
            }
        })
        console.log('年份',this.searchForm.arrYear)
    },
    yearChange(val){
            console.log(val)
        this.searchForm.arrYear.forEach(e=>{
            if(val==e.value){
                this.searchForm.yearname=e.label
            }
        })
        if(val==-1){
            this.searchForm.yearname=0
        }
        console.log(111111,this.searchForm.yearname)
        // this.searchForm.quarter_array_str=''
    },
    // 审核年份
    checkedFormyearChange(val){
        this.checkedForm.arrYear.forEach(e=>{
            if(val==e.value){
                this.checkedForm.yearname=e.label
            }
        })
        if(val==-1){
            this.checkedForm.yearname=0
        }
        console.log(111111,this.checkedForm.yearname)
        // this.searchForm.quarter_array_str=''
    },
    searchFormchange(num2,parentID) {    
        this.villageList=[]; 
        this.searchForm.villageID = ""
        this.region_level=5
        this.getRegionList(5,parentID)
    },
    //列表
    async getapplyaudit1userlist(page,page_size,key_words,policy_measure_id,account_nature,year,audit_status,age_range_type,enjoy_census_region_level,countryID,villageID,current_census_region_level,current_census_region_id,id_number) {
        console.log(page,page_size,key_words,policy_measure_id,account_nature,year,audit_status,age_range_type,enjoy_census_region_level,countryID,villageID,current_census_region_level,current_census_region_id)
        if(policy_measure_id==''){
            policy_measure_id=0
        }
        if(account_nature==''){
            account_nature=0
        }
        if(year==''){
            year=0
        }
        if(audit_status==''){
            audit_status=-1
        }
        let enjoy_census_region_id =0
        if(enjoy_census_region_level== 4){
          if(countryID==-1){
             enjoy_census_region_id =0
             enjoy_census_region_level=0
          }else if(countryID ===''&& villageID === ''){
            enjoy_census_region_id = 0
            enjoy_census_region_level=0
          }else if((countryID!==-1 && countryID!=='') &&(villageID!==-1 && villageID!=='') ){
            enjoy_census_region_id = villageID
            enjoy_census_region_level=5
          }else if((countryID!==-1 && countryID!=='') && (villageID==-1 || villageID=='') ){
            enjoy_census_region_id = countryID
            enjoy_census_region_level=4
          }
        }
        if(enjoy_census_region_level== 5){
          if(villageID==-1 || villageID==''){
            enjoy_census_region_id = 0
            enjoy_census_region_level=0
          }else{
            enjoy_census_region_id=villageID
            enjoy_census_region_level=5
          }
        } 
        if(enjoy_census_region_level==-1){
            enjoy_census_region_level=0
        }
        if(enjoy_census_region_level !=4 && enjoy_census_region_level !=5  ){
            enjoy_census_region_level=0
            enjoy_census_region_id=0
        }
      this.applyaudituserlist = [];
      this.showDataLoading = true;
      await rewardannualreviewuserlistModel.rewardannualreviewuserlist(page,page_size,key_words,policy_measure_id,account_nature,year,audit_status,age_range_type,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number).then((response) => {
          this.showDataLoading = false;
          if(response.data.lsp !==null){
              this.lsp=response.data.lsp
          }
          switch (response.data.code) {
            case 100:
              this.applyaudituserlist = response.data.result;
              this.applyaudituserlist.forEach(e=>{
                    e.applyTime = publicFun.timestampToTime(e.applyTime).substring(0,10)
                    e.userBirthday = publicFun.timestampToTime(e.userBirthday).substring(0,10)
                    e.marriageChanges = publicFun.timestampToTime(e.marriageChanges).substring(0,10)  
            })
               this.datailtotalCount =  response.data.recordcount;
             
              break;
            case 101:
             this.applyaudituserlist=[]
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch((error) => {});
    },

  //更改每页显示条数
    async handledatailSizeChange(val) {
      this.pagesize = val;
      this.page = 1;
      this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0,this.certificateNo)
    },
    //设置当前页
    async handledatailCurrentChange(val) {
      this.page = val;
        this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0,this.certificateNo)
    },
    // 查询
    async onSearch() {
      this.datailtotalCount = 0;
      this.page = 1;
      this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0,this.certificateNo)
      this.selectpolicy = this.searchForm.policy
    //   await this.getapplyaudit1userlist(this.page,this.pagesize,this.detailsearchForm.keywords,this.checkedForm.policy_measure_id)
    },
    // 导出
    onDownload(){

    },
    //获取搜索框的不通过原因下拉框
    async getSystemcodeinfogetlist(mark,policyID) {
        await systemcodeModule
            .systemcodeinfogetlist(mark,policyID)
            .then((response) => {
                console.log(1111222,response)
            switch (response.data.code) {
                case 100:{
                    this.checkedForm.noPassReasonList = response.data.result
                }   
                break;
                
            }
            })
            .catch((error) => {
            console.log("error", error);
        });
    },
   selectchange(val){
        this.checkedForm.noPassReasonList.forEach(e=>{
             if(e.systemCodeID == val){
                 this.checkedForm.systemCode = e.systemCode
             }      
        })
   
   },
    // 查看资料
    editFunds(row){
      this.keyindex++
      this.dialogdataFormVisible=true
      this.applyRecordID=row.rewardRecordID
      //审核  
      this.markrewardRecordID=row.rewardRecordID
      this.markpolicyMeasureID=row.policyMeasureID
      this.markuserID=row.userID
      //转态值   
      if(this.region_level==5){
          if(row.auditStatus==0){
              this.markauditStatusID=1
          }else{
              this.markauditStatusID=0
          }
          console.log('转态值 ',this.markauditStatusID,row.auditStatus)
      }
      if(this.region_level==4){
          if((row.auditStatus==1 || row.auditStatus==2)&&row.confirmStatus==0){
              this.markauditStatusID=1
          }else{
              this.markauditStatusID=0
          }
      }
     //展示审核
      this.markshowID=4
    },
    clearlookoverList(){
        // this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0)
    },
    getTypedata(val){
      console.log('关闭页面事件')
      this.dialogdataFormVisible=val
      this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0,this.certificateNo)
   
    },
    // 批量审核
    handleSelectionPolicyChange(val){
        this.multiplePolicySelection = val;
        this.checkedForm.selectType=1
        console.log(val)
    },
    onclickApplaylist(){
        if( this.selectpolicy ===''){
             this.$message.error('请筛选年审政策');
            return
        }
         if(this.multiplePolicySelection == ''){
            this.$message.error('请选择申请人 ');
            return
        }
        this.getSystemcodeinfogetlist(18,this.selectpolicy)

        this.checkedForm.type=1
        this.dialogFormVisible = true
    },
   checkboxSelect(row, rowIndex){
      if(this.isshow==false){
        if(row.auditStatus!=3){
            return true // 禁用
        }else{
            return false // 不禁用
        }
      }else{
          return false // 不禁用
      }
    },
    onclickApplay(row){
        // rewardRecordID:奖扶对象记录id
        // policyMeasureID:政策措施id
        // userID:用户ID
        this.checkedForm.type=2
        this.rewardRecordIDlist= `[` + row.rewardRecordID + `]`
        this.policyMeasureIDlist= `[` + row.policyMeasureID + `]`
        this.userIDlist= `[` + row.userID + `]`
         this.getSystemcodeinfogetlist(18, row.policyMeasureID)
        this.dialogFormVisible = true
    },
    oncheckSubmit(){
        if(this.checkedForm.stattime==''){
                this.$message.error('请选择年审日期');
                return
            }
          if(this.checkedForm.is_audit_pass == '0'){
              
                if( this.checkedForm.noPassReason==''){
                    this.$message.error('请选择不通过原因');
                        return
                }
                
           }
           if(this.checkedForm.noPassReason==''){
               this.checkedForm.noPassReason=0
           }
          console.log(this.checkedForm.is_audit_pass)
          if(this.checkedForm.type == 1){
            let rewardRecordIDlist = []
            let policyMeasureIDlist = []
            let userIDlist = []
            console.log('this.multiplePolicySelection',this.multiplePolicySelection)
            this.multiplePolicySelection.forEach(e=>{  
               rewardRecordIDlist.push(e.rewardRecordID)
               policyMeasureIDlist.push(e.policyMeasureID)
               userIDlist.push(e.userID)
            })
            console.log(`[` + rewardRecordIDlist.toString()+ `]`,`[` + userIDlist.toString()+ `]`,`[` + policyMeasureIDlist.toString()+ `]`,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.yearname,this.checkedForm.stattime)
            this.applybatchapprove(`[` + rewardRecordIDlist.toString()+ `]`,`[` + userIDlist.toString()+ `]`,`[` + policyMeasureIDlist.toString()+ `]`,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.yearname,this.checkedForm.stattime )
          }else{
           // 当前年度 
            console.log(this.rewardRecordIDlist,this.userIDlist,this.policyMeasureIDlist,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.yearname,this.checkedForm.stattime )
            this.applybatchapprove(this.rewardRecordIDlist,this.userIDlist,this.policyMeasureIDlist,Number(this.checkedForm.is_audit_pass) ,this.checkedForm.noPassReason,this.checkedForm.yearname,this.checkedForm.stattime )
          }
    },
      //审核审核--CGX
    async applybatchapprove(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,audit_year,audit_time)  {
      await rewardannualreviewuserlistModel
        .rewardannualreviewbatchaudit(apply_record_ids,user_ids,policy_measure_id,is_audit_pass,no_pass_reason_id,audit_year,audit_time) 
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                  this.dialogFormVisible = false
                  const h = this.$createElement;
                  this.$notify({
                      title: "成功",
                      message: h("span", response.data.message),
                      type: "success",
                  });
                  this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0,this.certificateNo)
                }
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },
    clearEditList(checkedForm){
        this.$refs[checkedForm].resetFields();
        console.log("sdhkas")
        var now = new Date(); 
        var FullYeartime=now.getFullYear()+"-"+((now.getMonth()+1)<10?"0":"")+(now.getMonth()+1)+"-"+(now.getDate()<10?"0":"")+now.getDate();
        this.checkedForm.stattime=new Date(FullYeartime.split(" ")).getTime();
        this.checkedForm.noPassReason = '' 
        this.checkedForm.is_audit_pass = '0' 
        var myDate = new Date();       
        this.checkedForm.yearname=myDate.getFullYear()
        this.checkedForm.arrYear.forEach(e=>{
            if(this.checkedForm.yearname==e.label){
                this.checkedForm.year=e.value
            }
        })
        this.$forceUpdate()
    },
    turnAnnualReview(row){
        let apply_record_ids = []
        let user_ids = []
        let policy_measure_ids = []
        apply_record_ids.push(row.rewardRecordID)   
        user_ids.push(row.userID) 
        policy_measure_ids.push(row.policyMeasureID) 
        console.log( `[` + apply_record_ids.toString()+ `]`,`[` + user_ids.toString()+ `]`,`[` + policy_measure_ids.toString()+ `]`,2 )
        this.rewardchangeannualreview( `[` + apply_record_ids.toString()+ `]`,`[` + user_ids.toString()+ `]`,`[` + policy_measure_ids.toString()+ `]`,2 )
    },
    //转年审
    async rewardchangeannualreview(apply_record_ids,user_ids,policy_measure_ids,mark) {
      await applyauditfinishModel
        .rewardchangeannualreview(apply_record_ids,user_ids,policy_measure_ids,mark)
        .then((response) => {
          switch (response.data.code) {
            case 100:{
                this.getapplyaudit1userlist(this.page,this.pagesize,this.searchForm.keywords,this.searchForm.policy,this.searchForm.registered,this.searchForm.yearname,this.searchForm.annual,0,parseInt(store.getters.adminRegionLevel) +1,this.searchForm.countryID,this.searchForm.villageID,0,0,this.certificateNo)
                const h = this.$createElement;
                this.$notify({
                    title: "成功",
                    message: h("span", response.data.message),
                    type: "success",
                });
              }
              break;
            case 101:
            case 103:
              this.$message.error(response.data.message);
              break;
            case 100002:
                this.$message.error(baseconfig.no_permission_message);
            break;    
            case 102:
                this.$message.error(response.data.message);
            break;
            default:
                this.$message.error(response.data.message);
            break;
          }
        })
        .catch(function (error) {});
    },

   
  },
};
</script>

